import { EnvironmentProviders, Provider } from '@angular/core';
import { ListingPageService } from 'src/app/shared/components/listing-page/listing-page.service';
import { QueryParamsHandlerService } from 'src/app/shared/components/listing-page/services/query-params-handler/query-params-handler.service';
import { LISTING_MODEL } from 'src/app/shared/constants/tokens';
import { HistoryLogListingFiltersSourceService } from './history-log-listing-filters-source.service';
import { HistoryLogListingDataSourceService } from './history-log-listing-data-source.service';
import { HistoryLogListingExportConfigService } from './history-log-listing-export-config.service';
import { HistoryLogListingModelService } from './history-log-listing-model.service';

export const provideHistoryLogListing = (): (Provider | EnvironmentProviders)[] => [
  HistoryLogListingFiltersSourceService,
  HistoryLogListingDataSourceService,
  HistoryLogListingExportConfigService,
  { provide: LISTING_MODEL, useClass: HistoryLogListingModelService },
  ListingPageService,
  QueryParamsHandlerService
];
